// cs-ecommerce/src/store/account/state.js
export default function () {
    return {
      userData: {},
    }
  }